/**
 * 법률 문서 개정일 표시.
 *
 * 개정일은 `content/legals/{doc}/{locale}.md` 의 frontmatter `lastUpdated`(ISO)에만
 * 둔다. 예전에는 본문 첫 줄에 로케일 표기로 박혀 있었는데, 그러면 본문을 개정하면서
 * 날짜 줄을 안 고치는 사고가 난다 — 실제로 terms 번역본이 2026-08-13 내용을 담고
 * 날짜만 2024-06-05 로 남아 있었다. 표시는 이 함수가 로케일별로 만든다.
 */
const LOCALE_TAG: Record<string, string> = {
  en: "en-US",
  ko: "ko-KR",
  ja: "ja-JP",
  zh: "zh-CN",
  de: "de-DE",
  fr: "fr-FR",
  es: "es-ES",
};

export function formatLegalDate(
  iso: string | null,
  locale?: string,
): string | null {
  if (!iso) return null;
  const [y, m, d] = iso.split("-").map(Number);
  if (!y || !m || !d) return iso;
  // UTC 고정 — 서버·브라우저 타임존 차이로 하루가 밀리면 안 된다
  return new Intl.DateTimeFormat(LOCALE_TAG[locale ?? "en"] ?? "en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
    timeZone: "UTC",
  }).format(new Date(Date.UTC(y, m - 1, d)));
}
